var _path, _path2, _path3, _path4, _path5, _g, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSk46(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.10641 30.5416C6.93824 29.9927 5.97544 29.5491 5.97544 28.655C5.97544 27.971 6.5236 27.4736 7.60198 27.4736C7.99787 27.4736 8.32584 27.5165 8.66161 27.5806C8.83652 27.6095 9.02549 27.636 9.1801 27.636C10.1226 27.636 10.6552 27.0746 11.0089 26.0056L11.1557 25.5667C11.005 25.5066 9.46356 24.8296 7.45283 24.8296C4.25675 24.8296 2.56696 26.8817 2.56931 29.0135C2.56931 30.0864 2.90586 30.8672 3.43216 31.4794C4.11229 32.2689 5.07744 32.7866 5.98012 33.2262C7.29666 33.8743 8.48591 34.3522 8.48591 35.3111C8.48591 36.1623 7.60744 36.648 6.43068 36.648C4.82444 36.648 3.41811 35.7265 3.24007 35.6149L1.9165 38.0957C2.15076 38.2284 3.85149 39.3107 6.65635 39.3107C9.63847 39.3099 11.8967 37.5944 11.8967 34.9574C11.8967 32.3368 9.80245 31.3631 8.10641 30.5416Z",
    fill: "#E21837"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7772 31.7641L25.1909 25.1182H21.3343L17.0176 30.8552H16.9528V25.1182H13.7739V39.1971H13.9629C15.3364 39.1971 16.9731 38.56 16.9731 36.2634V33.0291H17.0403L21.4405 39.0238H25.4845L19.7772 31.7641Z",
    fill: "#E21837"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3723 10.0361C24.251 10.247 22.5917 11.2629 22.5979 13.0659C22.601 14.6979 23.9371 15.6872 23.941 17.8284C23.9465 19.4401 23.061 20.5247 22.1021 21.126C22.4894 21.09 22.9149 21.0682 23.3803 21.0682C24.3611 21.0651 24.9499 21.158 24.9866 21.1658L30.0083 14.9931C28.6121 12.9027 26.9832 11.2808 25.3723 10.0361Z",
    fill: "#E21837"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5902 26.6983C30.2211 25.716 30.3031 24.1441 30.3554 22.5441C30.4148 21.0535 30.7256 19.9298 32.7183 19.922C33.1595 19.9196 33.582 19.9821 34.3441 19.9798C37.2637 19.9673 39.1683 18.9592 40.3552 18.2993C37.9322 16.7532 34.3941 15.172 30.008 14.9932C29.7229 15.8045 27.499 21.9936 27.3296 22.4926C27.3569 22.523 27.7458 22.9603 28.2323 23.813C28.9499 24.9835 29.3333 25.9752 29.5902 26.6983Z",
    fill: "#E21837"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1603_29243",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 6,
    width: 8,
    height: 16
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0044 6.34814H24.6616V21.6418H17.0044V6.34814Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1603_29243)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9823 21.6422C18.7309 21.6422 18.6044 21.4743 18.5708 21.183C18.5388 20.8902 17.2816 9.38883 17.0942 7.64516C17.0677 7.38982 17.0044 6.92364 17.0044 6.75654C17.0021 6.48792 17.1778 6.34815 17.3847 6.34815C17.9789 6.34659 21.2195 7.10793 24.6616 9.52236C23.6707 9.80113 21.8754 10.835 21.8833 12.9746C21.8918 14.8643 23.2435 15.9067 23.2513 17.8081C23.2607 20.8941 19.7195 21.6406 18.9823 21.6422Z",
    fill: "#F37725"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8774 27.5163C29.9313 27.6623 29.9821 27.7849 30.0344 27.8677C30.1125 28.0043 30.2148 28.0652 30.3444 28.0652C30.4233 28.0652 30.5209 28.0348 30.6294 27.9856C30.8949 27.8638 41.3796 22.9771 42.9608 22.2462C43.1927 22.1369 43.6246 21.9425 43.7714 21.8581C43.9174 21.7738 43.9845 21.6481 43.9845 21.5224C43.9845 21.4529 43.9635 21.3818 43.926 21.3162C43.7292 20.9968 42.7117 19.9192 41.0149 18.7417C39.6687 19.482 37.5658 20.6322 34.4369 20.6439C33.6685 20.6454 33.4975 20.5908 32.9743 20.5963C31.447 20.6009 31.0667 21.253 31.0089 22.5945C30.9995 22.8475 30.9988 23.1879 30.9808 23.5628C30.9332 24.7629 30.7926 26.4137 29.8774 27.5163Z",
    fill: "#F37725"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSk46);
export default __webpack_public_path__ + "static/media/SK증권-46.2b0324d9d718cedf9c301908c7a57594.svg";
export { ForwardRef as ReactComponent };